import React from "react";
import { toast, ToastOptions } from "react-toastify";
import { ZeusAlert } from "zeus-front-design-system";
import useIsMobile from "./useIsMobile";

const base: ToastOptions = {
  icon: false,
  hideProgressBar: true,
  autoClose: 4000,
  position: "top-right",
  className: "toastShell",
  bodyClassName: "toastBody",
  closeButton: false,
};

function renderToast(
  title: string,
  subtitle: string = "",
  variant: "error" | "success" | "info" | "warning",
  opts?: ToastOptions,
  isMobile?: boolean
) {
  return toast(
    (t: any) => (
      <ZeusAlert
        title={title}
        subtitle={subtitle}
        type={variant}
        onCloseAlert={() => toast.dismiss(t.id)}
        animation="ScaleUp"
      />
    ),
    {
      ...base,
      ...opts,
      position: isMobile ? "top-center" : base.position,
      style: { ...opts?.style, padding: 0, borderRadius: 0 },
    }
  );
}

export function useToast() {
  const isMobile = useIsMobile();
  return {
    error: (title: string, sub?: string, o?: ToastOptions) =>
      renderToast(title, sub, "error", o, isMobile),
    success: (title: string, sub?: string, o?: ToastOptions) =>
      renderToast(title, sub, "success", o, isMobile),
    info: (title: string, sub?: string, o?: ToastOptions) =>
      renderToast(title, sub, "info", o, isMobile),
    warn: (title: string, sub?: string, o?: ToastOptions) =>
      renderToast(title, sub, "warning", o, isMobile),
  };
}
